module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av482-c3c43498e8ae63c71d4bb84a0a65db1d.jpg";